<div class="row mt-4 mb-2" [formGroup]="form">
  <div class="col-6">
    Всего: <b>{{count}}</b>
  </div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'">
                      <option [value]="''">{{el.caption}}</option>
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      <!-- // -->
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>{{row['date_time']}}</td>
          <td>
            @if (row['user_transfer_id']) {
              <a [routerLink]="['/physical/edit', row['user_transfer_id'], 'common']">{{row['user_transfer']}}</a>
            }
          </td>
          <td>
            @if (row['transfer_affairs_user_id']) {
              <a [routerLink]="['/physical/edit', row['transfer_affairs_user_id'], 'common']">{{row['transfer_affairs_user']}}</a>
            }
          </td>
          <td>
            @if (row['subagent_id']) {
              <a [routerLink]="['/entity/edit', row['subagent_id'], 'common']">{{row['subagent']}}</a>
            }
          </td>
          <td>
            @if (row['new_subagent_id']) {
              <a [routerLink]="['/entity/edit', row['new_subagent_id'], 'common']">{{row['new_subagent']}}</a>
            }
          </td>
          <td>
            @if (row['author_id']) {
              <a [routerLink]="['/physical/edit', row['author_id'], 'common']">{{row['author_fio']}}</a>
            }
          </td>
          <td>
            @if (row['leads']) {
              @for (lead of row['leads']; track lead) {
                <div>
                  @if (lead) {
                    <a [routerLink]="['/reservation/lead-info', lead.id]"> {{lead.fio}} </a>
                    }<br>
                  </div>
                }
              } @else {
                -
              }
            </td>
          </tr>
        }
      </table>
    </div>
  </div>

  <div class="alt-pagination">
    <app-paginator
      [queryParams]="filter_columns"
      [itemsPerPage]="50"
      [itemCount]="count"
      [currentPage]="current_page"
      [baseUrl]="'/transfer-log'">
    </app-paginator>
  </div>
